<annotated-control [field]="field" class="quoted-product">
  @for (value of values; track extractId(i, value); let i = $index) {
  <div class="line flex-wrap">
    @if (value.required) {
    <div class="product">{{ value.product_name }}</div>
    } @if (!value.required) {
    <basic-select
      [value]="value.id"
      (valueChange)="updateProduct(i, $event)"
      placeholder="Product..."
      id="productSelect-{{ field.name }}"
      [disabled]="disabled"
      [options]="getProductOptions(value.id)"
      (blur)="touch()"
      class="product"
    ></basic-select>
    }
    <div class="form-label-group">
      <input
        [ngModel]="value.description"
        (ngModelChange)="updateDescription(i, $event)"
        maxlength="255"
        placeholder="Description"
        id="descriptionInput-{{ field.name }}"
        class="form-control description"
      />
      <label class="form-label" for="descriptionInput-{{ field.name }}"
        >Description</label
      >
    </div>
    <div class="d-flex">
      <k2-select
        [value]="value.currencies_id"
        (valueChange)="updateCurrency(i, $event)"
        placeholder="Currency..."
        [disabled]="disabled"
        [options]="currencyOptions"
        (blur)="touch()"
        class="currency"
      ></k2-select>
      <div class="form-label-group">
        <input
          min="0"
          type="number"
          [ngModel]="value.amount"
          (ngModelChange)="updateAmount(i, $event)"
          placeholder="Amount"
          id="amountInput-{{ field.name }}"
          class="amount form-control"
        />
        <label class="form-label" for="amountInput-{{ field.name }}"
          >Amount</label
        >
      </div>
      <!--      <div class="form-label-group">-->
      <!--        <input min="0"-->
      <!--               type="number"-->
      <!--               readonly-->
      <!--               [ngModel]="value.global_rate"-->
      <!--               (ngModelChange)="updateGlobalRate(i, $event)"-->
      <!--               (mousedown)="preventClick($event)"-->
      <!--               tabindex="-1"-->
      <!--               placeholder="Global Rate"-->
      <!--               id="globalRateInput-{{field.name}}"-->
      <!--               class="amount form-control globalRate"/>-->
      <!--        <label class="form-label" for="globalRateInput-{{field.name}}">Global Rate</label>-->
      <!--      </div>-->
      <div class="form-label-group">
        <input
          min="0"
          type="number"
          [ngModel]="value.negotiated_rate"
          (ngModelChange)="updateNegotiatedRate(i, $event)"
          placeholder="Negotiated Rate"
          id="negotiatedRateInput-{{ field.name }}"
          class="amount form-control"
        />
        <label class="form-label" for="negotiatedRateInput-{{ field.name }}"
          >Negotiated Rate</label
        >
      </div>
      <div class="buttons">
        @if (!isBespoke) {
        <a (click)="requestRate(value.id)">
          <icon type="arrow-repeat"></icon>
        </a>
        } @if (i === values.length - 1 && canAddEmptyValue()) {
        <a (click)="addEmptyValue()">
          <icon type="plus-lg"></icon>
        </a>
        } @if (isRemovableValue(value)) {
        <a (click)="removeValue(i)" class="remove">
          <icon type="dash-lg"></icon>
        </a>
        }
      </div>
    </div>
  </div>
  }
</annotated-control>
